import { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";

const AgentFavoritePathVarsSchema = z.object({
  id: z.string()
});

export const ZAgentFavorites = {
  /**
   * POST /api/agents/:id/favorite
   * Mark an agent as a workspace favorite. Idempotent.
   */
  Favorite: {
    method: "POST" as const,
    path: "/api/agents/:id/favorite",
    PathVars: AgentFavoritePathVarsSchema,
    Response: ApiSuccessSchema(z.object({ success: z.literal(true) }))
  },

  /**
   * DELETE /api/agents/:id/favorite
   * Remove an agent from workspace favorites. Idempotent.
   */
  Unfavorite: {
    method: "DELETE" as const,
    path: "/api/agents/:id/favorite",
    PathVars: AgentFavoritePathVarsSchema,
    Response: ApiSuccessSchema(z.object({ success: z.literal(true) }))
  }
} as const;
